import {GROUPS} from "../../../utils/constants";
import {timestampToDate} from "../../../utils/date";

export const getDaysPassed = (createdAt) => {
  if (!createdAt) return "未知日期";
  const createdDate = createdAt ? timestampToDate(createdAt) : new Date();
  const today = new Date();
  const differenceInTime = today.getTime() - createdDate.getTime();

  return Math.floor(differenceInTime / (1000 * 60 * 60 * 24));
};

export const getGroupNameByPath = (path: string) => {
  return GROUPS.find(group => group.path === path)?.name || ''
}
